module.exports = __webpack_public_path__ + "assets/devices/Recessed-18518ea8580db7c7092ed772f7a31008.svg";